import { VideoResponse } from "./video-response";

export interface LiveVideoResponse extends VideoResponse {
    active: boolean;
    ivs: boolean;
}
